import { autoinject, bindable } from 'aurelia-framework';
import { Uuid } from '../../helpers/uuid';

@autoinject
export class Spinner {
	@bindable id;

	attached() {
		if (!this.id) {
			this.id = 'loading-spinner-' + Uuid.next();
		}
	}
}
